import { AxiosResponse } from 'axios';
import { appAlertData, appAlertDelete, appAlertList, appAlertUpdate } from '@/api/appAlert';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IAppAlertApiListResponse, IAppAlertDataResponse, IAppAlertDeleteParams, IAppAlertFilters, IAppAlertUpdateParams } from '@/types/appAlert';

export const appAlertService = {
    async list(params: IListParams<IAppAlertFilters>): Promise<AxiosResponse<IAppAlertApiListResponse>> {
        try {
            const response = await baseListService<IAppAlertApiListResponse>(appAlertList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('AppAlert API Error:', e);
            throw new AppError('Unable to load app alert list, request error', { cause: e });
        }
    },

    async update(params: IAppAlertUpdateParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await appAlertUpdate(params);
        } catch (e) {
            console.error('AppAlert Update API Error:', e);
            throw new AppError('Unable to update app alert, request error', { cause: e });
        }
    },

    async delete(params: IAppAlertDeleteParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await appAlertDelete(params);
        } catch (e) {
            console.error('AppAlert Delete API Error:', e);
            throw new AppError('Unable to delete app alert, request error', { cause: e });
        }
    },

    async data(params: { data_id: number }): Promise<AxiosResponse<IAppAlertDataResponse>> {
        try {
            return await appAlertData(params);
        } catch (e) {
            console.error('AppAlert Data API Error:', e);
            throw new AppError('Unable to load app alert data, request error', { cause: e });
        }
    },
};
